<template>
    <div class="wrap">
        <div class="mobile" v-if="equipment=='mobile'">
            <Mindex />
        </div>
        <div class="computer" v-else>
            <Cindex />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Mindex from "./Mobile/index.vue";
import Cindex from "./Computer/index.vue";
export default {
    data() {
        return {};
    },

    components: {Mindex,Cindex},

    computed: {
        ...mapState({
            equipment:state => state.equipment.equipment,
        })
    },

    created() {},

    mounted() {},

    methods: {},
};
</script>
<style lang="less" scoped></style>
